export default class StringUtil {
  static htmlToText(html: string): string {
    const tmp = document.createElement('div')
    tmp.innerHTML = html
    const text = tmp.textContent || tmp.innerText || ''
    return text.substring(0, 19)
  }
}
